import { gql } from "@apollo/client"; // saveFinalizarVisita.js


const SAVE_FINALIZAR_VISITA = gql`
  mutation saveFinalizarVisita($input: AddVisitaFinalizarInput!) {
    saveFinalizarVisita(input: $input) {
      idVisita
    }
  }
`;

export default SAVE_FINALIZAR_VISITA;

export const adaptAddVisitaFinalizarInput = (data) => ({
  idVisita: data?.idVisita,
  fechaFinUsuario: data?.fechaFin,
  conformidad: !!data?.conformidad,
  obsConformidad: data?.obsConformidad,
  idComboVisitaValorInterlocutor: data?.idComboVisitaValorInterlocutor,
  nombreCompleto: data?.interlocutorNombre || data?.nombreCompleto,
  codigoAtencion: data?.codigoAtencion,
  dni: data?.dNI?.toString(),
  finalizada: !!data?.finalizada,
  latitud: data?.coordenadas?.latitud?.toString(),
  longitud: data?.coordenadas?.longitud?.toString(),
  desdeCoordinacion: !!data?.desdeCoordinacion
});